import { render, staticRenderFns } from "./Locataires.vue?vue&type=template&id=61f270a4&"
import script from "./Locataires.vue?vue&type=script&lang=js&"
export * from "./Locataires.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports